// This is duplicated in end-to-end-tests
export const HIRING_PERMISSION = Object.freeze({
  ALL: 'ALL',
  NONE: 'NONE',
});

export const EMPLOYEE_PERMISSION = Object.freeze({
  ALL: 'ALL',
  SUPERVISOR: 'SUPERVISOR',
  NONE: 'NONE',
});
